module.exports = __webpack_public_path__ + "static/img/two.da4a198.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/6/two.png
// module id = 0sau
// module chunks = 1